import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "41",
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M28.6663 23.9926C29.128 23.9926 29.3588 23.9926 29.5459 24.0951C29.7003 24.1797 29.8439 24.3385 29.9127 24.5005C29.996 24.6969 29.975 24.9059 29.9331 25.3238C29.7157 27.4906 28.9699 29.5784 27.7526 31.4002C26.2875 33.5929 24.2051 35.3019 21.7688 36.311C19.3324 37.3202 16.6516 37.5842 14.0651 37.0698C11.4787 36.5553 9.10296 35.2854 7.23826 33.4207C5.37356 31.556 4.10368 29.1803 3.58921 26.5938C3.07474 24.0074 3.33878 21.3265 4.34795 18.8902C5.35712 16.4538 7.06609 14.3715 9.25874 12.9064C11.0806 11.689 13.1684 10.9433 15.3352 10.7259C15.7531 10.684 15.9621 10.663 16.1585 10.7463C16.3205 10.8151 16.4793 10.9587 16.5638 11.113C16.6663 11.3001 16.6663 11.531 16.6663 11.9926V22.6593C16.6663 23.126 16.6663 23.3594 16.7572 23.5376C16.8371 23.6944 16.9646 23.8219 17.1214 23.9018C17.2996 23.9926 17.533 23.9926 17.9997 23.9926H28.6663Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M23.333 5.32597C23.333 4.86429 23.333 4.63346 23.4355 4.44637C23.5201 4.29203 23.6789 4.14838 23.8409 4.07965C24.0373 3.99632 24.2462 4.01729 24.6642 4.05921C27.7115 4.36487 30.5764 5.71314 32.7611 7.89788C34.9458 10.0826 36.2941 12.9475 36.5998 15.9948C36.6417 16.4128 36.6627 16.6217 36.5793 16.8181C36.5106 16.9801 36.367 17.1389 36.2126 17.2235C36.0255 17.326 35.7947 17.326 35.333 17.326L24.6663 17.326C24.1996 17.326 23.9663 17.326 23.788 17.2351C23.6312 17.1552 23.5037 17.0278 23.4238 16.871C23.333 16.6927 23.333 16.4593 23.333 15.9926V5.32597Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }